module.exports = __webpack_public_path__ + "img/contact_7.69290b8a.png";